/**
 * Q/W/E/T jump to a shown magnification. Users can change each key's target in the Shortcuts app;
 * overrides live in MorpheusSetting.keyboard_shortcuts.bindings as {Q: 5, ...}.
 */
export const DEFAULT_ZOOM_PRESETS = {Q: 5, W: 10, E: 20, T: 40};

export const ZOOM_PRESET_CHOICES = [0.5, 1, 1.25, 2, 2.5, 4, 5, 10, 20, 40, 60, 80, 100, 200];

/** `bindings` also holds non-zoom keys (the seen-area heatmap), so only preset keys are read. */
export const getZoomPresets = (keyboardShortcuts) => {
    const bindings = keyboardShortcuts?.bindings || {};
    return Object.fromEntries(Object.entries(DEFAULT_ZOOM_PRESETS).map(([key, value]) =>
        [key, bindings[key] ?? value]));
};

/** `KeyQ` → 'Q' when Q is a preset key, else null. */
export const getPresetKey = (eventCode) => {
    const key = /^Key([A-Z])$/.exec(eventCode || '')?.[1];
    return key && key in DEFAULT_ZOOM_PRESETS ? key : null;
};

/** Zoom index in [min, max] whose label is closest to the target magnification (by ratio). */
export const nearestZoomIndex = (zoomScale, min, max, targetMag) => {
    if (!(targetMag > 0) || !zoomScale?.length) return null;
    let best = null;
    let bestDistance = Infinity;
    for (let idx = Math.max(0, Math.ceil(min)); idx <= Math.min(max, zoomScale.length - 1); idx++) {
        const label = zoomScale[idx];
        if (!(label > 0)) continue;
        const distance = Math.abs(Math.log(label / targetMag));
        if (distance < bestDistance - 1e-9) {
            best = idx;
            bestDistance = distance;
        }
    }
    return best;
};
